import {NgModule} from '@angular/core';
import {IonicModule} from 'ionic-angular';
import {ImageUploadService} from '../../services/image-upload/image-upload-service';
import {EditImageModalModule} from '../edit-image-modal/edit-image-modal.module';

import {ImageUploadComponent} from './index';

/**
 * Module for the ImageUploadModule
 * @class
 */
@NgModule({
  declarations: [ImageUploadComponent],
  exports: [ImageUploadComponent],
  imports: [IonicModule, EditImageModalModule],
  providers: [ImageUploadService],
})
export class ImageUploadModule {
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/image-upload/image-upload.component.module.ts